import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

/**
 * Slider — supports single OR multi-thumb usage.
 * Pass `value` (or `defaultValue`) as an array; renders one thumb per entry.
 *   <Slider value={[age]} min={18} max={80} />                                // single
 *   <Slider value={[minAge, maxAge]} min={18} max={99} />                     // range
 * Range fill sits between the outermost thumbs automatically (Radix behaviour).
 */
const Slider = React.forwardRef(({ className, ...props }, ref) => {
  const thumbCount =
    (Array.isArray(props.value) && props.value.length) ||
    (Array.isArray(props.defaultValue) && props.defaultValue.length) ||
    1;
  return (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      {...props}>
      <SliderPrimitive.Track
        className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-primary/20">
        <SliderPrimitive.Range className="absolute h-full bg-primary" />
      </SliderPrimitive.Track>
      {Array.from({ length: thumbCount }, (_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          // Larger visual + touch target on mobile (h-5 w-5 = 20px) so range thumbs stay separable.
          // The extra ring on active/focus + touch-manipulation help finger interaction.
          className="block h-5 w-5 rounded-full border-2 border-primary bg-background shadow-md transition-all touch-manipulation focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 active:scale-110 disabled:pointer-events-none disabled:opacity-50" />
      ))}
    </SliderPrimitive.Root>
  );
})
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
